module.exports = __webpack_public_path__ + "static/media/aed.99b3eb51.svg";